import styled from 'styled-components';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getCreateMetadata, getUuid } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import { EDIT_ACTIONS } from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import { useFlpAccess } from 'automation-ui-permissions/flp/hooks/useFlpAccess';
import ReadOnlyFeaturesBanner from 'automation-ui-canvas/components/common/ReadOnlyFeaturesBanner';
import FlpRestrictedPropertiesMessage from 'automation-ui-management/components/flp/FlpRestrictedPropertiesMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MaxWidthWrapper = styled.div.withConfig({
  displayName: "ReadOnlyBanner__MaxWidthWrapper",
  componentId: "sc-1sda61u-0"
})(["max-width:75%;"]);
export const getIsAdsSimpleWorkflow = uuid => {
  if (uuid) {
    // The uuid prefix for new ads simple workflows is 'adss' which will always be present
    const [prefix] = uuid.split('-');
    return prefix === 'adss';
  }
  return false;
};
const ReadOnlyBanner = ({
  editFeatures,
  flow
}) => {
  const sourceApp = getCreateMetadata(flow).getSourceApp();
  const {
    loading: loadingFlpData,
    data: flpData,
    error: flpDataError
  } = useFlpAccess(flow.flowId);
  const getShowLegacyAdsFlowSunsetBanner = () => {
    if (!sourceApp) {
      return false;
    }
    const uuid = getUuid(flow);
    const isAdsSimpleWorkflow = sourceApp === SourceApps.ADS_FLOW && getIsAdsSimpleWorkflow(uuid);
    return sourceApp === SourceApps.ADS_FLOW && !isAdsSimpleWorkflow;
  };
  const showLegacyAdsFlowSunsetBanner = getShowLegacyAdsFlowSunsetBanner();
  if (showLegacyAdsFlowSunsetBanner) {
    return /*#__PURE__*/_jsx(MaxWidthWrapper, {
      children: /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.readOnlyBanner.adsLegacyEmbeddedFlow.title"
        }),
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.common.readOnlyBanner.adsLegacyEmbeddedFlow.content"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "automation.common.readOnlyBanner.adsLegacyEmbeddedFlow.secondaryContent"
          })]
        })
      })
    });
  }
  if (loadingFlpData) {
    return null;
  }
  if (flpDataError) {
    return /*#__PURE__*/_jsx(MaxWidthWrapper, {
      children: /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.accessErrorBanner.title"
        }),
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.accessErrorBanner.content"
        })
      })
    });
  }
  if (flpData !== null && flpData !== void 0 && flpData.isDowngradeScenario()) {
    return /*#__PURE__*/_jsx(MaxWidthWrapper, {
      children: /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.readOnlyBanner.flpDowngrade.title"
        }),
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FlpRestrictedPropertiesMessage, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.common.readOnlyBanner.flpDowngrade.content"
          }),
          flpRejectionReasons: flpData.flpRejectionReasons
        })
      })
    });
  }
  if (!(flpData !== null && flpData !== void 0 && flpData.hasAccess(EDIT_ACTIONS))) {
    var _flpData$flpRejection;
    return /*#__PURE__*/_jsx(MaxWidthWrapper, {
      children: /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.readOnlyBanner.flpReadOnly.title"
        }),
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FlpRestrictedPropertiesMessage, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.common.readOnlyBanner.flpReadOnly.content"
          }),
          flpRejectionReasons: (_flpData$flpRejection = flpData === null || flpData === void 0 ? void 0 : flpData.flpRejectionReasons) !== null && _flpData$flpRejection !== void 0 ? _flpData$flpRejection : []
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(ReadOnlyFeaturesBanner, {
    flow: flow,
    sourceApp: sourceApp,
    editFeatures: editFeatures
  });
};
const ensureDefinedProps = ReadOnlyBannerComponent => {
  return props => {
    var _props$editFeatures;
    if (!props.flow) {
      return null;
    }
    return /*#__PURE__*/_jsx(ReadOnlyBannerComponent, Object.assign({}, props, {
      editFeatures: (_props$editFeatures = props.editFeatures) !== null && _props$editFeatures !== void 0 ? _props$editFeatures : []
    }));
  };
};
export default ensureDefinedProps(ReadOnlyBanner);